import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ROLE_MODERATOR } from '../../services/permissions-checker';
import { openModal } from '../../actions/open-modal';
import { buttonClicked } from '../../actions/button-clicked';
import { BlockIcon, ModeratorIcon, ReportIcon } from '../../components/icons';
import ActionButton from '../../components/action-button';
import {
  MODAL_TYPE_REPORT_MEMBER,
  MODAL_TYPE_PROMOTE_MODERATOR,
  MODAL_TYPE_DEMOTE_MODERATOR,
  MODAL_TYPE_BLOCK_MEMBER,
  MODAL_TYPE_UNBLOCK_MEMBER,
} from '../../constants/modal-types';
import { getUserRole } from '../../services/user-role';
import withPermissions from '../../hoc/with-permissions';
import withTranslate from '../../hoc/with-translate';

const isModerator = user => getUserRole(user) === ROLE_MODERATOR;

export class PublicProfileActions extends Component {
  handleBlockClick = () => {
    const { user, buttonClicked, openModal } = this.props;
    const modal = user.isBlocked ? MODAL_TYPE_UNBLOCK_MEMBER : MODAL_TYPE_BLOCK_MEMBER;
    buttonClicked({ action: 'block_user', flag: Number(user.isBlocked) });
    return openModal(modal, { userId: user._id });
  };

  handleReportClick = () => {
    const { user, buttonClicked, openModal } = this.props;
    buttonClicked({ action: MODAL_TYPE_REPORT_MEMBER });
    return openModal(MODAL_TYPE_REPORT_MEMBER, { userId: user._id });
  };

  handlePromoteClick = () => {
    const { user, buttonClicked, openModal } = this.props;
    const modal = isModerator(user) ? MODAL_TYPE_DEMOTE_MODERATOR : MODAL_TYPE_PROMOTE_MODERATOR;
    buttonClicked({ action: modal });
    return openModal(modal, { userId: user._id });
  };

  render() {
    const { canRender, user, triggerButton: TriggerButton, emptyNode, t } = this.props;
    const reportButton = canRender('report', 'member', user, () => (
      <ActionButton
        data-hook="public-profile-actions__report"
        className="public-profile-actions__report"
        onClick={this.handleReportClick}
      >
        <ReportIcon className="forum-icon-fill"/>
        {t('public-profile-actions.report-member')}
      </ActionButton>
    ));
    const promoteModeratorButton = canRender('promote-moderator', 'member', user, () => (
      <ActionButton
        data-hook="public-profile-actions__promote"
        className="public-profile-actions__promote"
        onClick={this.handlePromoteClick}
      >
        <ModeratorIcon className="forum-icon-fill"/>
        {t(isModerator(user) ? 'public-profile-actions.demote-moderator' : 'public-profile-actions.promote-moderator')}
      </ActionButton>
    ));
    const blockButton = canRender('block', 'member', user, () => (
      <ActionButton
        data-hook="public-profile-actions__block"
        className="public-profile-actions__block"
        onClick={this.handleBlockClick}
      >
        <BlockIcon className="forum-icon-fill"/>
        {t(user.isBlocked ? 'public-profile-actions.unblock-member' : 'public-profile-actions.block-member')}
      </ActionButton>
    ));

    if (reportButton || promoteModeratorButton || blockButton) {
      return (
        <TriggerButton>
          <div>
            {reportButton}
            {promoteModeratorButton}
            {blockButton}
          </div>
        </TriggerButton>
      );
    }
    return emptyNode || null;
  }
}

PublicProfileActions.propTypes = {
  triggerButton: PropTypes.any.isRequired,
  emptyNode: PropTypes.node,
  user: PropTypes.object.isRequired,
  buttonClicked: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  canRender: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      buttonClicked: data => buttonClicked({ name: 'action_click', type: 'profile', ...data }),
      openModal,
    },
    dispatch
  );

// prettier-ignore
export default flowRight(
  connect(undefined, mapDispatchToProps),
  withPermissions,
  withTranslate
)(PublicProfileActions);



// WEBPACK FOOTER //
// ./app/containers/public-profile-actions/public-profile-actions.js